"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var DatePicker_base_1 = require("./DatePicker.base");
var DatePicker_styles_1 = require("./DatePicker.styles");
/**
 * DatePicker description
 */
exports.DatePicker = Utilities_1.styled(DatePicker_base_1.DatePickerBase, DatePicker_styles_1.styles, undefined, {
    scope: 'DatePicker'
});
//# sourceMappingURL=DatePicker.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DatePicker/DatePicker.js
// module id = 861
// module chunks = 0